export default __webpack_public_path__ + "static/media/888.c12ba087.png";